export default "__VITE_ASSET__BJUYr6U5__"